import {EmailCreate, EmailResource} from '@/interfaces';
import {CrudApiAbstract} from '@/api/CrudApiAbstract';
import {ResourceType} from '@/enums';

export class EmailApi extends CrudApiAbstract<EmailResource, EmailCreate> {
  public constructor() {
    super(`${ResourceType.Email}s`);
  }
}
